var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgByTrain(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "by-train",
    transform: "translate(-457 -1473)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_143",
    "data-name": "Ellipse 143",
    transform: "translate(457 1473)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "MDI_train",
    "data-name": "MDI / train",
    transform: "translate(462 1478)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Boundary",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 24,
    height: 24,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_train",
    "data-name": "Path / train",
    d: "M12.5,2C8.25,2,4,2.526,4,6.211v10a3.7,3.7,0,0,0,3.719,3.684L6.125,21.474V22H8.494l2.125-2.105h4.006L16.75,22h2.125v-.526l-1.594-1.579A3.7,3.7,0,0,0,21,16.211v-10C21,2.526,17.2,2,12.5,2M7.719,17.789a1.579,1.579,0,1,1,1.594-1.579,1.586,1.586,0,0,1-1.594,1.579m3.719-7.368H6.125V6.211h5.313v4.211m2.125,0V6.211h5.313v4.211H13.563m3.719,7.368a1.579,1.579,0,1,1,1.594-1.579A1.586,1.586,0,0,1,17.281,17.789Z",
    transform: "translate(0 1)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgByTrain);
export default __webpack_public_path__ + "static/media/by-train.25514efa40897b2c5cf4e895b049b1f7.svg";
export { ForwardRef as ReactComponent };